module.exports = __webpack_public_path__ + "img/footer.f6d92ac0.png";